import type { TuitionErrorData, TuitionErrorCode } from '@/types/subscription'
import {
  TUITION_URL,
  DEFAULT_TUITION_PATH,
  TUITION_ERROR_MESSAGES,
  TUITION_ERROR_ACTIONS
} from '@/config/tuition'

const KNOWN_CODES = new Set<string>([
  'tuition_required',
  'tuition_past_due',
  'tuition_expired',
  'tuition_cancelled',
  'tuition_suspended',
  'payment_failed',
  'trial_expired'
])

/** Maps legacy API `subscription_*` codes to normalized `tuition_*`. */
const LEGACY_SUBSCRIPTION: Record<string, TuitionErrorCode> = {
  subscription_required: 'tuition_required',
  subscription_past_due: 'tuition_past_due',
  subscription_expired: 'tuition_expired',
  subscription_cancelled: 'tuition_cancelled',
  subscription_suspended: 'tuition_suspended'
}

export function normalizeTuitionErrorCode(raw: string | undefined): TuitionErrorCode {
  if (!raw) return 'tuition_required'
  if (KNOWN_CODES.has(raw)) return raw as TuitionErrorCode
  return LEGACY_SUBSCRIPTION[raw] ?? 'tuition_required'
}

export function createTuitionError(detail: any, fallbackMessage?: string): TuitionErrorData {
  const errorCode = normalizeTuitionErrorCode(detail?.error)

  return {
    error: errorCode,
    message:
      detail?.message ||
      fallbackMessage ||
      TUITION_ERROR_MESSAGES[errorCode] ||
      TUITION_ERROR_MESSAGES.tuition_required,
    action:
      detail?.action ||
      TUITION_ERROR_ACTIONS[errorCode] ||
      TUITION_ERROR_ACTIONS.tuition_required,
    action_url: detail?.action_url || DEFAULT_TUITION_PATH,
    status: detail?.status
  }
}

export function resolveTuitionRedirectHref(actionUrl?: string): string {
  const raw = (actionUrl ?? DEFAULT_TUITION_PATH).trim()
  const path = raw.startsWith('/') ? raw : `/${raw}`
  return `${TUITION_URL}${path}`
}

export function redirectToTuitionPortal(actionUrl?: string): void {
  window.location.href = resolveTuitionRedirectHref(actionUrl)
}
